// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e942c7d6","453":"66ba96d6"}[chunkId] + ".chunk.js";
};